import Instafeed from 'instafeed.js'

export function initInstagramFeed() {
	$('[data-ig]').once('InstagramFeed').each(function () {
		const $feed = $(this)
		const accessToken = JSON.parse($feed.data('igAccessToken'))
		const userId = JSON.parse($feed.data('igUserId'))

		const feed = new Instafeed({
			accessToken,
			userId,
			target: $feed.find('.instagram-feed__content').get(0),
			get: 'user',
			limit: 10,
			resolution: 'low_resolution',
			sortBy: 'most-recent',
			template: '<div class="instagram-photo"><a rel="noreferrer" href="{{link}}"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=" data-src="{{image}}" class="lazyload" alt="{{caption}}"></a></div>',
			after() {
				$feed.removeClass('js-not-yet')
			},
			error(e) {
				console.log('Oh no, an error :(')
			}
		})
		feed.run()

		$feed.data('instafeed', feed)
	})
}